import { render, staticRenderFns } from "./u-btn-hamburger-concave.vue?vue&type=template&id=2aca226d&scoped=true&"
import script from "./u-btn-hamburger-concave.vue?vue&type=script&lang=js&"
export * from "./u-btn-hamburger-concave.vue?vue&type=script&lang=js&"
import style0 from "./u-btn-hamburger-concave.vue?vue&type=style&index=0&id=2aca226d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca226d",
  null
  
)

export default component.exports